import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { CreditCard, ShieldCheck, Loader2, ArrowLeft } from "lucide-react";
import api from "../lib/api";
import { getErrorMessage } from "../lib/utils";

const CheckoutPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleCheckout = async () => {
    setLoading(true);
    try {
      const originUrl = window.location.origin;
      const response = await api.post("/payments/create-checkout", {
        origin_url: originUrl,
      });

      if (response.data.url) {
        window.location.href = response.data.url;
      } else {
        toast.error("Erro ao criar sessão de pagamento");
      }
    } catch (error) {
      toast.error(getErrorMessage(error, "Erro ao iniciar pagamento"));
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-md animate-fade-in">
        <div className="text-center mb-8">
          <h1 className="font-heading text-3xl font-bold text-primary mb-2">
            EstoqueClinic
          </h1>
          <p className="text-slate-500">
            Sistema de Gestao de Estoque para Clinicas de Estetica
          </p>
        </div>

        <Card className="border-slate-200 shadow-soft border-primary/30">
          <CardHeader className="text-center space-y-2">
            <div className="mx-auto w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-2">
              <CreditCard className="h-8 w-8 text-primary" />
            </div>
            <CardTitle className="text-2xl font-heading">Acesso Vitalicio</CardTitle>
            <CardDescription>
              Pague uma unica vez e tenha acesso completo ao sistema para sempre.
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="text-center">
              <div className="text-4xl font-bold text-primary">
                R$ 29,90
              </div>
              <p className="text-sm text-slate-500 mt-1">Pagamento unico - Acesso vitalicio</p>
            </div>

            <div className="space-y-3 text-sm text-slate-600">
              <div className="flex items-center gap-2">
                <ShieldCheck className="h-4 w-4 text-green-500 flex-shrink-0" />
                <span>Acesso completo a todas as funcionalidades</span>
              </div>
              <div className="flex items-center gap-2">
                <ShieldCheck className="h-4 w-4 text-green-500 flex-shrink-0" />
                <span>Gestao de produtos, fornecedores e estoque</span>
              </div>
              <div className="flex items-center gap-2">
                <ShieldCheck className="h-4 w-4 text-green-500 flex-shrink-0" />
                <span>Relatorios e alertas de vencimento</span>
              </div>
              <div className="flex items-center gap-2">
                <ShieldCheck className="h-4 w-4 text-green-500 flex-shrink-0" />
                <span>Sem mensalidades ou taxas adicionais</span>
              </div>
            </div>

            <Button
              onClick={handleCheckout}
              className="w-full h-12 text-base"
              disabled={loading}
              data-testid="checkout-buy-btn"
            >
              {loading ? (
                <>
                  <Loader2 className="mr-2 h-5 w-5 animate-spin" />
                  Redirecionando para pagamento...
                </>
              ) : (
                <>
                  <CreditCard className="mr-2 h-5 w-5" />
                  Comprar Agora
                </>
              )}
            </Button>

            <button
              onClick={() => navigate("/login")}
              className="flex items-center justify-center w-full text-sm text-slate-500 hover:text-primary transition-colors"
              data-testid="checkout-back-login-btn"
            >
              <ArrowLeft className="h-4 w-4 mr-1" />
              Ja tenho uma conta
            </button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default CheckoutPage;
